import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import ModalComponent from '../../../../core/common/modal/ModalComponent'
import { useDeactivateUserToggleMutation, useDeleteLeadInquiryMutation, useDeleteLeadPropectMutation } from '../../../../services/EndPointsApis'
import { all_routes } from '../../../router/all_routes'

type Props = {
    show: boolean
    handleClose: () => void
    data?: any
    setCurrentToggleState?:any
    refetch?:any
    prospectId?:any
    handleDeleteRow?:any
}



const LeadInqDeleteModal = ({ show, handleClose, data,prospectId,refetch,handleDeleteRow }: Props) => {
    const route = all_routes;
    const [deleteLeadProspect, { data: deActivedata, isError, error, isSuccess }] = useDeleteLeadInquiryMutation();
    const navigate = useNavigate();

    const [inquiryIdState,setInquiryIdState]=useState(null)

    useEffect(() => {
        if (prospectId && prospectId.length > 0) {
          const ProspectId = prospectId[0];
          
         
          setInquiryIdState(ProspectId);
        }
      }, [prospectId]); 

    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message);
            handleClose();
            refetch()
            if (inquiryIdState && handleDeleteRow) {
                handleDeleteRow(inquiryIdState);  
            }
            setInquiryIdState(null)
           
        }
    }, [isSuccess]);
    // useEffect(() => {
    //     if (isError && error) {
    //         let errorMessage: string = 'Something went wrong';

    //         if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
    //             errorMessage = (error.data as { message: string }).message;
    //         }
    //         toast.error(errorMessage);
    //     }
    // },
    //     [isError, error]);

    const handelDelete=()=>{
        deleteLeadProspect({LeadInquiryId:inquiryIdState})
    }
    return (
        <ModalComponent
            buttonText=""
            modalTitle='Delete Lead Inquiry'
            onClose={handleClose}
            onSave={handelDelete}
            isVisible={show}
            cancelButton="Cancel"
            saveButton='Delete'
        >
            <>
                <p>
                    Are you sure you want to Delete Lead Inquiry.
                </p>
            </>

        </ModalComponent>
    )
}

export default LeadInqDeleteModal